import { Avatar, AvatarImage } from "../ui/Avatar";

export function Logo({ className = "h-[36px] w-[280px]", logoImage }) {
  return (
    <Avatar>
      <AvatarImage 
        src={logoImage} 
        alt="Logo" 
        className={className}
        data-name="logo / full"
      />
    </Avatar>
  );
}